import { BaseService } from './base';
import { ApiRequest } from '../lib/request';
import type { ApiResponse } from '../lib/response';

import { Location } from '../models/location';

export class LocationService extends BaseService<Location> {
  override model = Location;
  override modelName = 'location';
  override modelLabel = 'Location';

  override get modelBaseUrl(): string {
    return `/api/v${this.modelApiVersion}/settings/`;
  }

  async getLocation(): Promise<ApiResponse<Location>> {
    const request = new ApiRequest({
      method: 'GET',
      url: `${this.modelBaseUrl}${this.modelName}`,
    });

    return await this.requestItem(request, Location);
  }

  async saveLocation(
    location: Location,
  ): Promise<ApiResponse<Location>> {
    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}${this.modelName}`,
      data: location.toJSON(),
    });

    return await this.requestItem(request, Location);
  }

  async loyaltyProgramBulkSet(
    type: string,
    status: boolean,
  ): Promise<ApiResponse<any>> {
    const data: Record<string, string> = {};
    data[type] = status ? 'on' : 'off';

    const request = new ApiRequest({
      method: 'POST',
      url: `${this.modelBaseUrl}loyaltyProgramBulkSet`,
      data,
    });

    return await this.requestItem(request, Location);
  }
}
